import React from 'react';

interface AccessabilityStartProps {
    targetElementId: string;
    linkText: string;
}

export const AccessabilityStart = (props: AccessabilityStartProps): React.ReactElement => {
    const { targetElementId, linkText } = props;

    const element = document && document.getElementById(targetElementId);
    if (!element) {
        return null;
    }

    const handleOnClick = (event) => {
        event.preventDefault();
        element.scrollIntoView();
        element.tabIndex = -1;
        element.focus();
        element.blur();
    };

    return (
        <div className="accessability-start d-none d-lg-block">
            <a className="accessability-start__link btn" href="#" onClick={handleOnClick} accessKey="s">
                {linkText}
            </a>
        </div>
    );
};
